import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {BreadcrumbService} from '../../../../breadcrumb.service';
import {ProjectBranchService} from '../../../../core/services';
import {TokenService} from '../../../../core/auth';
import {ActivatedRoute, Router} from '@angular/router';
import {EventService, PageRequest} from '../../../../core';
import {Project, ProjectBranchResponse} from '../../../../core/models';
import {Subject} from 'rxjs';
import {ProjectSidebarService} from '../../../../projectsidebar.service';
import {DataTable} from 'primeng/datatable';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';

@Component({
  selector: 'app-project-branch-list',
  templateUrl: './project-branch-list.page.html'
})
export class ProjectBranchListPage implements OnInit {
  @Input() query = new PageRequest(1, 20);
  project: Project;
  projectBranchResponse: ProjectBranchResponse = new ProjectBranchResponse();
  @ViewChild('dt') dt: DataTable;
  searchTerms = new Subject<string>();
  loading = false;
  id: string;
  authUser = this.token.whoAmI();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private token: TokenService,
    private eventService: EventService,
    private projectBranchService: ProjectBranchService,
    private breadcrumbService: BreadcrumbService,
    private projectSidebarService: ProjectSidebarService,
  ) {
  }

  ngOnInit() {
    this.searchTerms.pipe(
        debounceTime(1000),
        distinctUntilChanged())
        .subscribe(value => {
          this.dt.reset();
        });

    this.loading = true;
    this.route.parent.params.subscribe((params) => {
      this.id = params.id;
    });

    this.route.parent.data.subscribe((data) => {
      if (data.project) {
        this.project = Object.assign({}, data.project);
        this.query.projectId = this.project.id;
        this.loadProjectBranches(this.query);
        this.breadcrumbService.setItems([
          {label: 'projects', routerLink: ['/project', 'list']},
          {label: this.project.name},
          {label: 'branches'},
        ]);
        this.projectSidebarService.setProject(this.project);
      }
      this.loading = false;
    });
  }

  search(query: PageRequest): void {
    this.loadProjectBranches(query);
  }

  change(query: PageRequest): void {
    this.loadProjectBranches(query);
  }

  onSortChange(event) {
    this.query.sortField = event.value.sortField;
    this.query.sortDir = event.value.sortDir;
    this.loadProjectBranches(this.query);
  }

  paginate(event) {

    if (event.sortField !== undefined && event.sortField == 'transactions') {
      if (event.sortOrder == 1) {
        this.projectBranchResponse.content.sort(function (a, b) {
          return a.transactions.length - b.transactions.length;
        });
      } else {
        this.projectBranchResponse.content.sort(function (a, b) {
          return b.transactions.length - a.transactions.length;
        });
      }
      return;
    }

    this.query.page = (event.first / event.rows) + 1;
    this.query.sortField = (event.sortField !== undefined) ? event.sortField : 'name';
    this.query.sortDir = this.query.getSortDir(event.sortOrder);
    this.loadProjectBranches(this.query);
  }

  loadProjectBranches(query: PageRequest) {
    query.sortField = !query.sortField ? 'creationDate' : query.sortField;
    query.sortDir = !query.sortDir ? 'desc' : query.sortDir;

    this.projectBranchService.search(query).subscribe(
      (data) => {
        this.projectBranchResponse = data;

      }
    );
  }
}
